<template>
  <v-container>
    <v-row>
      <v-col
        v-for="dataset in datasetList"
        v-if="currSubStepInStep2===1"
        :key="dataset.name"
        cols="12"
        sm="6"
        md="4"
        lg="4"
      >
        <!-- dataset cards list START -->
        <trigger-dataset-card
          :dataset="dataset"
          :curr-sub-step="currSubStepInStep2"
          :trigger="trigger"
          @click.native="clickedOn(dataset)"
          @sendTriggerState="updateTrigger"
        />
        <!-- dataset cards list END -->
      </v-col>
    </v-row>
    <v-row justify="center">
      <!-- selected dataset card START -->
      <v-col
        v-if="currSubStepInStep2===2"
        cols="12"
        sm="6"
        md="4"
        lg="4"
      >
        <trigger-dataset-card
          :dataset="chosenDataset"
          :curr-sub-step="currSubStepInStep2"
          :curr-step="currStep"
          :trigger="trigger"
          :curr-fetch="currFetch"
          :curr-request="currRequest"
          @buttonClicked="buttonClicked"
          @sendTriggerState="updateTrigger"
        />
      </v-col>
      <!-- selected dataset card END -->
    </v-row>
  </v-container>
</template>
<script>

  import TriggerService from './services/TriggerService'
  import TriggerDatasetCard from './Cards/TriggerDatasetCard.vue'

  export default {
    components: {
      TriggerDatasetCard,
    },
    props: {
      trigger: {},
      currSubStep: Number,
      currStep: Number,
    },
    data () {
      return {
        datasetList: [],
        chosenDataset: {},
        currSubStepInStep2: this.currSubStep,
        currRequest: '',
        currFetch: '',
      }
    },
    watch: {
      currSubStep: function () {
        this.currSubStepInStep2 = this.currSubStep
      },
    },
    mounted: function () {
      TriggerService.getDatasetList(this)
        .then(result => {
          this.datasetList = result.data.results
        })
    },
    methods: {
      clickedOn (clickedDataset) {
        this.currSubStepInStep2 = 2
        this.chosenDataset = clickedDataset
        this.trigger.source = clickedDataset
        this.$emit('nextStep')
        this.$emit('sendTriggerState', this.trigger)
      },
      updateTrigger (newTriggerState) {
        this.trigger = newTriggerState
        this.$emit('sendTriggerState', this.trigger)
      },
      buttonClicked (type) {
        if (type === 'PRE' || type === 'POST') {
          this.trigger.fetch_choice = type
          this.currFetch = type
        }
        this.$emit('sendTriggerState', this.trigger)
      },
    },
  }
</script>
